import { useEffect, useState } from "react"

const useSuperAdmin = email => {
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [isSuperAdminLoading, setIsSuperAdminLoading] = useState(true);
    useEffect(() => {
        if (email) {
            fetch(`https://tutor-tree-server-1.vercel.app/users/superAdmin/${email}`)
                .then(res => res.json())
                .then(data => {
                    console.log(data);
                    setIsSuperAdmin(data.isSuperAdmin);
                    setIsSuperAdminLoading(false);
                })
    }
    }, [email])
    return [isSuperAdmin, isSuperAdminLoading]
}

export default useSuperAdmin;